import { LILAC_400, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getAdditionalBenefitsStyles = (props, isSmallScreen) => {
  var additionalBenefits = props.additionalBenefits,
    hideDivider = props.hideDivider,
    hideOttText = props.hideOttText,
    buttonWidgetData = props.buttonWidgetData;
  var isAdditionalBenefitDataExist = additionalBenefits && additionalBenefits.length > 0;
  var showButtonWidget = buttonWidgetData && Object.keys(buttonWidgetData).length > 0;
  var spacingToken = tokens.spacing;
  var benefitsImagesDimensions = isSmallScreen ? {
    width: 28,
    height: 28
  } : {
    width: 32,
    height: 32
  };
  return StyleSheet.create({
    secondaryCardContainer: Object.assign(Object.assign(Object.assign({
      flexDirection: isAdditionalBenefitDataExist ? 'row' : 'row-reverse'
    }, !hideDivider && {
      paddingTop: spacingToken.SPACING_16
    }), showButtonWidget && {
      paddingBottom: spacingToken.SPACING_16
    }), {
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    }),
    benefitsContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row'
    },
    ottContainer: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }, !hideOttText && {
      flex: 1
    }),
    ottItem: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    distributedSpacing: {
      justifyContent: 'space-between',
      flex: 1
    },
    tertiaryActionButton: Object.assign(Object.assign({}, isAdditionalBenefitDataExist && {
      paddingLeft: spacingToken.SPACING_20
    }), {
      alignSelf: 'flex-end'
    }),
    descriptionText: {
      minHeight: 36,
      flex: 1,
      justifyContent: 'center'
    },
    viewDetailsButtonContainer: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    tertiaryViewDetailsButton: {
      alignSelf: 'center'
    },
    hiddenBenefitsCountContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: LILAC_400,
      padding: spacingToken.SPACING_7,
      borderRadius: spacingToken.SPACING_4,
      minWidth: benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.width,
      height: benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.height
    },
    benefitImage: Object.assign({
      borderRadius: tokens.borderRadius.BORDER_RADIUS_4
    }, hideOttText && {
      marginRight: tokens.spacing.SPACING_8
    }),
    benefitText: {
      marginLeft: tokens.spacing.SPACING_4,
      marginRight: tokens.spacing.SPACING_8
    },
    icon: {
      flexShrink: 0,
      marginRight: hideOttText ? tokens.spacing.SPACING_8 : tokens.spacing.SPACING_0
    }
  });
};